import { Car, Client, FilterParams, PagedResult } from "../users.type";
import { Constants, clientApiScope, userApiScope } from "@/services/web/api.const";
import { useApi, useApiAsync } from "@/services/web/use-api";

import { mergeParam } from "@/helper/api";

export const useGetClients = (
  filter: FilterParams,
  enabled = false,
): { loading: boolean; error?: Error; clients?: PagedResult<Client> } => {
  let url = Constants.MANAGEMENT_API_URL + "/clients";
  url = mergeParam(url, filter as Record<string, string | number>);

  const options = { method: "GET", ...userApiScope };

  const {
    isLoading: loading,
    error,
    data: clients,
  } = useApi<PagedResult<Client>>(url, options, ["clients", filter], enabled);

  return { loading, error, clients };
};

export const useGetClient = (userId: string): { loading?: boolean; error?: Error; client?: Client } => {
  const options = {
    method: "GET",
    ...userApiScope,
  };

  const url = Constants.MANAGEMENT_API_URL + "/clients/" + userId;
  const {
    isLoading: loading,
    error,
    data: client,
  } = useApi<Client>(url, options, ["client", userId], true, {
    retry: false,
    retryOnMount: true,
  });

  return {
    loading,
    error,
    client,
  };
};

export const useDeleteClient = (userId: string) => {
  const url = Constants.MANAGEMENT_API_URL + "/clients/" + userId;
  const options = {
    method: "Delete",
    ...userApiScope,
  };

  const { mutateAsync: deleteClient, isPending: loading, error } = useApiAsync(url, options, ["clients"]);
  return {
    deleteClient,
    loading,
    error,
  };
};

export const useGetClientCars = (userId: string) => {
  const options = {
    method: "GET",
    ...clientApiScope,
  };

  const url = Constants.CLIENTS_API_URL + "/clients/" + userId + "/cars";
  const {
    isLoading: loading,
    error,
    data: cars,
  } = useApi<Car[]>(url, options, ["cars", userId], true, {
    retry: false,
    retryOnMount: true,
  });

  return {
    loading,
    error,
    cars: cars || [],
  };
};
